<template>
<div class="row">
	<div class="col-12">
		<autocomplete-category :selected="activeCategory"
		                       :label="`${$t('item.category')} *`"
		                       :deletable="false"
		                       @update:category="categoryIsUpdated">
		</autocomplete-category>
	</div>
</div>
</template>
<script>
import AutocompleteCategory from '@/components/elements/AutocompleteCategory';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters, mapActions } = createNamespacedHelpers('item');

export default {
	name: 'category-field',
	components: {
		AutocompleteCategory
	},
	data: () => ({
		selectedCategory: null
	}),
	props: {
		mode: {
			type: String,
			default: 'add'
		},
	},
	computed: {
		...mapGetters([
			'item',
			'lastCreatedItem'
		]),
		activeCategory: {
			get() {
				if (this.selectedCategory) {
					return this.selectedCategory;
				}

				if (this.item) {
					return this.item.category;
				}

				if (this.lastCreatedItem) {
					return this.lastCreatedItem.category;
				}

				return null;
			},
			set(value) {
				this.selectedCategory = value;
			}
		}
	},
	watch: {
		//'item': 'selectedCategory',
		// '$route': 'setLastCreatedCategory'
	},
	methods: {
		/**
		 * Category is updated
		 * @param  {Object} category Selected category
		 */
		categoryIsUpdated(category) {
			this.activeCategory = category;
			this.$emit('update:category', category);
		},

		setLastCreatedCategory() {
			if (this.mode == 'add' && this.lastCreatedItem) {
				this.categoryIsUpdated(this.lastCreatedItem.category);
			}
		},
		resetSelection() {
			this.selectedCategory = null;
		}
	},
	mounted() {
		this.setLastCreatedCategory();
	}
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// CategoryField.vue?6f15369f